var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    fill: "#FF4D4D",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 23.3333C23 18.731 26.731 15 31.3333 15H39.6667V31.6667H31.3333C26.731 31.6667 23 27.9357 23 23.3333V23.3333Z",
    stroke: "#FF4D4D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.334 23.3333C56.334 18.731 52.603 15 48.0007 15H39.6673V31.6667H48.0006C52.603 31.6667 56.334 27.9357 56.334 23.3333V23.3333Z",
    stroke: "#FF4D4D",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.334 40.0001C56.334 35.3977 52.603 31.6667 48.0007 31.6667V31.6667C43.3983 31.6667 39.6673 35.3977 39.6673 40.0001V40.0001C39.6673 44.6025 43.3983 48.3334 48.0007 48.3334V48.3334C52.603 48.3334 56.334 44.6025 56.334 40.0001V40.0001Z",
    stroke: "#FF4D4D",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 40.0001C23 35.3977 26.731 31.6667 31.3333 31.6667H39.6667V48.3334H31.3333C26.731 48.3334 23 44.6025 23 40.0001V40.0001Z",
    stroke: "#FF4D4D",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 56.6666C23 52.0642 26.731 48.3333 31.3333 48.3333H39.6667V56.6666C39.6667 61.269 35.9357 64.9999 31.3333 64.9999V64.9999C26.731 64.9999 23 61.269 23 56.6666V56.6666Z",
    stroke: "#FF4D4D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/Figma.1f2cbbb5bb16cd9cae69de850b68b4d1.svg";
export { ForwardRef as ReactComponent };